import React from 'react';
import { connect } from 'react-redux';
import KeyForm from '../KeyForm';

const component = props => (
  <div>
    <KeyForm
      text={props.text}
      color={props.color}
      styles={props.styles}
      constants={props.constants}
      valid
      number="1234567890"
      submit={() => {}}
      clear={() => {}}
      redirect={() => {}}
      add={() => {}}
      remove={() => {}}
    />
  </div>
);

const mapStateToProps = state => ({
  text: state.text,
  constants: state.constants,
  color: state.color,
  styles: state.styles
});

const mapDispatchToProps = () => ({});

const HomePage = connect(mapStateToProps, mapDispatchToProps)(component);

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/KeyFormPage/index.js